<template lang="pug">
#LoginPage
    loadingOverlay(v-show='loading' message='Loading . . .' :zIndex='999')
    #login-gpt
        .login-page-gpt.pt-5.pt-md-1()
            v-container.fluid.pa-0.hidden-sm-and-down(style="margin-top:80px;")
                v-row.no-gutters.d-flex.justify-center
                    v-col(cols="12" class="form-panel")
                        v-card.flat.login-card(style="border-radius:15px!important;")
                            v-card-text
                                p.primary-login.text-center {{$t('LOGIN.LOGIN')}}
                                form
                                    v-text-field.text-input.mb-3(
                                        v-model="username"
                                        :label="$t('LOGIN.ACCOUNT')"
                                    )
                                        template(#prepend-inner)
                                            v-img(src="@/assets/images/username_icon.svg" width="20" height="20" alt="")
                                    v-text-field.text-input(
                                        v-model="password"
                                        :type="showPassword ? 'text' : 'password'"
                                        :label="$t('LOGIN.PWD')"
                                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        @click:append="togglePassword"
                                        style="margin-bottom:152px;"
                                    )
                                        template(#prepend-inner)
                                            v-img(src="@/assets/images/password_icon.svg" width="20" height="20" alt="")
                                    input.btn.primary-btn.w-100.py-3.mb-2(type="submit", :value=`$t('LOGIN.LOGIN')` @click='handleLogin($event)')
                                    .text-center
                                        a.forget(@click='forgetPassword = true') {{$t('FORGET_PASSWORD.TITLE')}}
        //- footer.footer
        //-     nav.py-md-2.py-5.text-center
        //-         p.d-inline ART Solutions All Rights Reserved.
        //-         span.mx-2 |
        //-         a.text-decoration-underline(href="/docs/DPF.pdf" target="_blank") Data Processing Agreement
    v-dialog(v-model='forgetPassword' max-width='500')
        forgetPassword-dialog(@emitForgetPasswordDialog='onEmitForgetPasswordDialog' @emitForgetPasswordSuccess='onEmitForgetPasswordSuccess' :notTenantcenterSate="notTenantcenterSate")
    v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog()')
        success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
    v-dialog(v-model='errorDialog' width='360' content-class='statusDialog')
        error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
    v-dialog(v-model='messageDialog' width='360' content-class='statusDialog')
        message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
</template>
<script>
import { mapActions } from 'vuex';
import successDialog from "@/components/Dialog/successDialog";
import errorDialog from "@/components/Dialog/errorDialog";
import messageDialog from "@/components/Dialog/messageDialog";
import loadingOverlay from "@/components/Common/loadingOverlay";
import forgetPasswordDialog from "@/components/Dialog/User/forgetPasswordDialog";
import passData from "@/services/passData.js";
import i18n from '/common/plugins/vue-i18n.js'
    export default {
        name: "UpGPT-Login",
        components: {
            errorDialog,
            successDialog,
            messageDialog,
            loadingOverlay,
            forgetPasswordDialog,
            passData
        },
        data() {
            return{
                notTenantcenterSate: false,
                loading: false,
                username: '',
                password: '',
                loginValiCode: '',
                showPassword: false,
                forgetPassword: false,
                noneusername:false,
                nonetenant:false,
                successDialog: false,
                errorDialog: false,
                errorMessage: '',
                messageDialog: false,
                message: '',
                displayNone: false,
                displayLoginVali: false,
                changePassword:false,
                nextPath: '/tenant_center/tenant_list',
            }
        },
        mounted() {
            this.updateAfterLoginNextPath();
        },
        created() {
            window.addEventListener('keyup', this.close)

            let nowPath = this.$router.currentRoute.fullPath;
            let test = 'upgpt-login?tenant=';
            let nullTenant = 'tenant=null';
            if(nowPath.includes(test) && !nowPath.includes(nullTenant)){
                this.displayNone = true;
            }

            let user = JSON.parse(window.localStorage.getItem('tenantcenter_user'));
            if(user != null)
            {
                let is_portal_user = user['is_portal_user'] || false;
                this.changePassword = user.change_password;
                if(this.changePassword){
                    if(window.location.href.includes('next=') && window.location.href.includes('UpGPT_Portal') && is_portal_user){
                        this.$router.replace('/UpGPT_Portal');
                    }else if(window.location.href.includes('next=') && window.location.href.includes('UpGPT_Portal') && !is_portal_user){
                        this.$router.replace('/upgpt/PermissionErrorPortal');
                    }else{
                        this.$router.replace('/upgpt/UserSetting/');
                    }
                }
                else{
                    let nextToPath = this.nextPath;
                    // if (window.location.href.includes('next=')) {
                    //     let urlNext = decodeURIComponent(window.location.href.split('next=')[1]);
                    //     nextToPath = urlNext;
                    // }
                    this.$router.replace(nextToPath);
                }
            }
        },
        methods: {
            togglePassword() {
                this.showPassword = !this.showPassword
            },
            onEmitForgetPasswordDialog(val) {
                this.forgetPassword = val;
            },
            onEmitForgetPasswordSuccess(val,errorMsg) {
                if(val){
                    this.forgetPassword = false;
                    this.successDialog = true;
                }else{
                    this.errorDialog = true;
                    this.errorMessage = errorMsg;
                }
            },
            updateAfterLoginNextPath() {
                if ('next' in this.$route.query) {
                    this.nextPath = this.$route.query.next;
                }
            },
            onEmitSuccessDialog() {
                this.successDialog = false;
            },
            onEmitErrorDialog(val) {
                if(val){
                    this.errorDialog = false;
                }
            },
            handleLogin(event) {
                event.preventDefault();
                if (this.username == ''|this.password == '')
                {
                    this.errorDialog = true;
                    if(this.username == ''|this.password == '')
                    {
                        this.errorMessage = i18n.t('LOGIN.ERROR');
                        this.noneusername = true
                    }else
                    {
                        this.errorMessage = i18n.t('LOGIN.ERROR_2');
                    }
                }
                else
                {
                    this.loading = true;
                    this.loginTenantCenter({ username: this.username, password: this.password, loginValiCode: this.loginValiCode })
                    .then(() => {
                        this.loading = false;
                        this.$emit('tenantLoginSuccess');
                        var user = JSON.parse(window.localStorage.getItem('tenantcenter_user'));
                        this.changePassword = user.change_password;
                        if(user.upchat_sso_link != '')
                        {
                            window.location.href = user.upchat_sso_link;
                        }
                        else
                        {
                            this.forwardToUpGPTPage();
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.errorDialog = true;
                        if(error.response){
                            this.errorMessage = i18n.t('LOGIN.ERROR_3');
                        }
                    })
                    .finally(() => {
                        passData.$emit("status");
                        // passData.$emit("upchat",window.localStorage.getItem('isUpchatUser'));
                        if(!this.errorDialog){
                        location.reload();
                    }
                    })
                }
            },
            forwardToUpGPTPage(){
                if(this.changePassword)
                {
                    let user = JSON.parse(window.localStorage.getItem('tenantcenter_user'));
                    if(user != null){
                        let is_portal_user = user['is_portal_user'] || false;
                        if(window.location.href.includes('next=') && window.location.href.includes('UpGPT_Portal') && is_portal_user){
                            this.$router.replace('/UpGPT_Portal');
                        }else if(window.location.href.includes('next=') && window.location.href.includes('UpGPT_Portal') && !is_portal_user){
                            this.$router.replace('/upgpt/PermissionErrorPortal');
                        }else{
                            this.$router.replace('/upgpt/UserSetting/')
                        }
                    }
                }
                else
                {
                    let nextToPath = this.nextPath;
                    // if (window.location.href.includes('next=')) {
                    //     let urlNext = decodeURIComponent(window.location.href.split('next=')[1]);
                    //     nextToPath = urlNext;
                    // }
                    this.$router.replace(nextToPath);
                }

            },
            onEmitMessageDialog(val) {
                this.messageDialog = false;
                console.log('onEmitMessageDialog: ' + val);
            },
            ...mapActions([
                'loginTenantCenter',
            ]),
            close(ev){
                if(this.errorDialog && ev.key == "Enter")
                {
                    if((!this.noneusername) | this.nonetenant )
                    {
                        this.errorDialog = false
                        this.nonetenant = false
                    }else
                    {
                        this.nonetenant = true
                    }
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    #login-gpt{
        background-image: url("~@/assets/images/CTA_BG.jpg");
        background-size: cover;
        background-position: top;
        background-repeat: no-repeat;
        height: calc(100vh - 60px);
    }
    .login-page-gpt {
        // padding-top: 100px;
        position: relative;
    }
    .primary-login{
        font-size: 36px;
        font-weight: 500;
        color: #222;
    }
    .bg-panel {
        position: relative;
        padding: 64px;
        .logo {
          width: 300px;
          margin-top: 40px;
          margin-bottom: 60px;
        }
        .welcome-text{
            color: #044958;
            text-align: center;
            h2 {
                font-size: 36px;
                margin-bottom: 36px;
            }
            .tagline {
                font-size: 28px;
                color: #1095AF;
                line-height: 1.5;
                font-weight: 500;

            }
        }
        .v-card{
            border-radius: 15px !important;
        }
    }
    .primary-mobile-login{
        font-size: 28px;
        font-weight: 500;
        color: #222;
    }
    .form-panel,
    .form-panel-mobile {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 32px;

        .login-card,
        .login-card-mobile{
            width: 90%;
            max-width: 500px;
            padding: 24px;
            border-radius: 15px !important;
        }
        .logo-mobile {
            width: 160px;
            margin: 25px auto 32px;
        }
        .forget {
            font-size: 0.875rem;
            color: #00acc1;
            text-decoration: none;
        }
        .v-card__text{
            line-height: unset;
        }
    }
    .footer {
        position: absolute;
        bottom: 0px;
        width: 100%;
        color: #546e7a;
        font-size: 0.75rem;
        background-color: #fff;
        nav a {
            color: inherit;
            text-decoration: none;
        }
        nav span {
            color: #b0bec5;
        }
    }
    .header-bar {
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: flex-start; /* 或 center、space-between */
      padding: 0 36px;
      background: #fff;
      box-shadow: 0px 4px 20px 0px #0043651A;
    }
    .theme--light.v-sheet{
        background-color: #ffffff33 !important;

        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(8.8px);
        -webkit-backdrop-filter: blur(8.8px);
        border: 1.5px solid rgba(255, 255, 255, 0.3);
    }
    .theme--light.v-input input,.theme--light.v-input textarea{
        font-size: small;
    }
    .primary-btn{
        color: white;
        background: linear-gradient(270deg, #097AB6 0%, #48BAF7 100%);

        border-radius: 50px;
    }
</style>
